const digest = 'd49d32a8a3caadca8dae8ce768618bf10d8913217247ccfa80b343a004d63cbc';
const css = `._viewHeight_gojf5_1{height:100vh}[data-testid=task-flow-wrapper-title]{font-weight:600}[data-testid=task-flow-header]>div>div:last-child{align-items:center;display:flex;gap:10px}[data-testid=close-button-r]{color:#006fcf}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'viewHeight': '_viewHeight_gojf5_1' };
export const viewHeight = '_viewHeight_gojf5_1';
export { css, digest };